import React, {useCallback} from 'react';
import {useLocalization} from 'localization';
import {useShortcut} from 'services/shortcuts';
import {FlexBox, IconButton} from 'components';
import {useWorkSizeContext} from '../../../contexts';

export const WorkCardTitle: React.FC = () => {
  const {t} = useLocalization();
  const {workSize, setWorkSize} = useWorkSizeContext();

  const onToggle = useCallback(() => {
    setWorkSize(workSize === undefined ? 'minimized' : undefined);
  }, [setWorkSize, workSize]);

  useShortcut('toggleWork', onToggle);

  return (
    <FlexBox alignItems={'center'} horizontal={workSize !== 'minimized'}>
      <IconButton
        icon={'Minus'}
        disabled={workSize === 'minimized'}
        onClick={() =>
          setWorkSize(workSize === 'maximized' ? undefined : 'minimized')
        }
      />
      {t('page.metadata.work.title')}
      <IconButton
        icon={'Add'}
        disabled={workSize === 'maximized'}
        onClick={() =>
          setWorkSize(workSize === 'minimized' ? undefined : 'maximized')
        }
      />
    </FlexBox>
  );
};
